import { Toast } from "vant";
import wx from "weixin-js-sdk";
import response from "./response";
import webconfig from "../webconfig.config";
import store from "../store";
const appid = webconfig.WeixinAppId || "wx68dad14acda9d438"; // 默认值防止缺失
// 全局默认分享图标（首页/列表等无商品图的场景兜底）
const DEFAULT_SHARE_LOGO = "https://apis.dtmyg.com/logo.png";
// 站点标题（默认分享文案）
const DEFAULT_SHARE_TITLE = "灯塔名医谷";
// 站点默认分享描述
const DEFAULT_SHARE_DESC = "聚古今良方，汇天下名医，解民间疾苦。";

// JSSDK 配置单例：整个会话只真正 wx.config 一次，所有分享调用等待该 Promise resolve
let _configPromise = null;
// 最近一次已设置的分享内容签名，用于去重，避免同一页重复调用触发 offline verifying
let _lastShareKey = "";

class WeiXin {
  static Getauthorize(code, that, success) {
    var openid = sessionStorage.getItem("OpenId");
    //console.log("Getauthorize - openid:", openid, "code:", code);
    
    // 如果已有 OpenId，直接执行回调
    if (openid != null && openid != "") {
      console.log("已有 openid：" + openid);
      if (typeof success === "function") {
        success();
      }
      return;
    }
    
    // 检查是否正在处理 code（防止重复处理）
    var isProcessingCode = sessionStorage.getItem("WeixinAuthProcessing");
    if (isProcessingCode === "true") {
      console.log("正在处理授权 code，跳过重复请求");
      return;
    }
    
    // 如果有 code，处理 code 获取 OpenId
    if (code != undefined && code != null && code != "") {
      // 标记正在处理，防止重复请求
      sessionStorage.setItem("WeixinAuthProcessing", "true");
      
      var _tuid = localStorage.getItem("tuid");
      console.log(_tuid, "tuid");
      
      that.$store
        .dispatch({
          type: "GetOpenId",
          code: code,
          tuid: _tuid,
          appId: appid
        })
        .then(res => {
          //console.log(res, "GetOpenId");
          response.callNotMsgResponse(res, result => {
            // 清除处理标志
            sessionStorage.removeItem("WeixinAuthProcessing");
            
            if (result.openid != null && result.openid != "") {
              sessionStorage.setItem("OpenId", result.openid);
              //console.log("成功获取 openid:", result.openid);
              
              // 授权成功后，清理 URL 中的 code 参数，避免重复授权
              if (that.$router && that.$route && that.$route.query.code) {
                var query = Object.assign({}, that.$route.query);
                delete query.code;
                delete query.state;
                that.$router.replace({
                  path: that.$route.path,
                  query: query
                });
              }
              
              // 执行成功回调
              if (typeof success === "function") {
                success();
              }
            } else {
              console.error("获取 openid 失败");
              // 如果获取失败，清除处理标志，允许重试
              sessionStorage.removeItem("WeixinAuthProcessing");
            }
          });
        })
        .catch(err => {
          console.error("GetOpenId 请求失败:", err);
          // 清除处理标志，允许重试
          sessionStorage.removeItem("WeixinAuthProcessing");
        });
      return;
    }
    
    // 如果没有 code 且没有 OpenId，才跳转授权
    // 清理 URL 中的 code 和 state 参数，避免重复授权
    var currentUrl = window.location.href;
    var urlObj = new URL(currentUrl);
    // 移除 code 和 state 参数
    urlObj.searchParams.delete("code");
    urlObj.searchParams.delete("state");
    // 获取清理后的 URL（不包含 hash）
    var cleanUrl = urlObj.origin + urlObj.pathname;
    if (urlObj.search) {
      cleanUrl += urlObj.search;
    }
    var redirectUri = encodeURIComponent(cleanUrl);
    console.log("跳转授权，redirect_uri:", cleanUrl);
    window.location.href =
      "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
      appid +
      "&redirect_uri=" +
      redirectUri +
      "&response_type=code&scope=snsapi_userinfo&connect_redirect=1&state=#wechat_redirect";
  }

  static GetJssdkConfig(that) {
    // 兼容传入 Vue 组件实例或直接传入 store
    const store = that && that.$store ? that.$store : that;

    // 已有进行中/已完成的配置流程，直接复用（避免并发重复 wx.config）
    if (_configPromise) {
      return _configPromise;
    }

    // 30 分钟内已配置成功：不重新 wx.config，但仍返回就绪态
    const configTime = sessionStorage.getItem("JssdkConfigTime");
    const now = Date.now();
    if (sessionStorage.getItem("JssdkConfig") && configTime &&
        (now - parseInt(configTime)) < 30 * 60 * 1000) {
      _configPromise = Promise.resolve(true);
      return _configPromise;
    }

    let currentUrl = location.href.split("#")[0];
    if (currentUrl.indexOf('?') === -1) {
      currentUrl = currentUrl.replace(/#$/, '');
    }
    console.log("开始获取微信配置，URL:", currentUrl);

    _configPromise = new Promise((resolve, reject) => {
      store
        .dispatch({
          type: "GetJssdkConfig",
          // 不要再 encodeURIComponent：GET 经 axios params 会自动编码一次
          url: currentUrl,
          // 传当前站点公众号 AppId，后端按此 AppId 取对应 token/ticket 出签
          appId: appid
        })
        .then(res => {
          response.callNotMsgResponse(res, result => {
            console.log("微信配置参数:", result);

            if (!result.timestamp || !result.nonceStr || !result.signature) {
              _configPromise = null;
              reject(new Error("微信配置参数不完整"));
              return;
            }

            wx.config({
              debug: false,
              appId: appid,
              timestamp: result.timestamp,
              nonceStr: result.nonceStr,
              signature: result.signature,
              jsApiList: [
                "chooseWXPay",
                "scanQRCode",
                "updateAppMessageShareData",
                "updateTimelineShareData",
                "onMenuShareAppMessage",
                "onMenuShareTimeline"
              ]
            });

            wx.ready(() => {
              console.log("微信 JSSDK 配置成功");
              sessionStorage.setItem("JssdkConfig", true);
              sessionStorage.setItem("JssdkConfigTime", Date.now().toString());
              resolve(true);
            });

            wx.error((err) => {
              console.error("微信 JSSDK 配置失败:", err);
              sessionStorage.removeItem("JssdkConfig");
              sessionStorage.removeItem("JssdkConfigTime");
              // 允许下次重新配置
              _configPromise = null;
              reject(new Error("微信 JSSDK 配置失败: " + JSON.stringify(err)));
            });
          });
        })
        .catch(err => {
          console.error("获取微信配置失败:", err);
          _configPromise = null;
          reject(err);
        });
    });

    return _configPromise;
  }

  static weiXinPay(data, s_callback, e_callback) {
    if (typeof WeixinJSBridge == "undefined") {
      //微信浏览器内置对象。参考微信官方文档
      if (document.addEventListener) {
        document.addEventListener(
          "WeixinJSBridgeReady",
          this.onBridgeReady(data, s_callback, e_callback),
          false
        );
      } else if (document.attachEvent) {
        document.attachEvent(
          "WeixinJSBridgeReady",
          this.onBridgeReady(data, s_callback, e_callback)
        );
        document.attachEvent(
          "onWeixinJSBridgeReady",
          this.onBridgeReady(data, s_callback, e_callback)
        );
      }
    } else {
      this.onBridgeReady(data, s_callback, e_callback);
    }
  }

  static onBridgeReady(data, s_callback, e_callback) {
    WeixinJSBridge.invoke(
      "getBrandWCPayRequest",
      {
        appId: data.appId, //公众号名称，由商户传入
        timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
        nonceStr: data.nonceStr, //随机串
        package: data.package,
        signType: data.signType, //微信签名方式：
        paySign: data.paySign //微信签名
      },
      function(res) {
        console.log(res);
        // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          //alert("支付成功！");
          Toast("支付成功！");
          if (typeof s_callback === "function") {
            s_callback();
          }
        } else {
          //Toast('支付失败,错误信息:' + res.errMsg);
          Toast("支付失败，用户已取消或者内部出错！");
          if (typeof e_callback === "function") {
            e_callback();
          }
        }
      }
    );
  }

  static IsWeiXin() {
    var _isWeiXin = false;
    var broser = window.navigator.userAgent.toLowerCase();
    console.log(broser);
    //通过正则表达式匹配broser 中是否含有MicroMessenger字符串
    if (broser.match(/MicroMessenger/i) == "micromessenger") {
      console.log("微信浏览器");
      _isWeiXin = true;
    }
    return _isWeiXin;
  }

  static AutoWeixinAuthorize(that,callBack) {
    var _this = this;
    console.log("AutoWeixinAuthorize");
    var _isWeiXin = this.IsWeiXin();
    if (_isWeiXin) {
      console.log("微信浏览器进入");
      var openid = sessionStorage.getItem("OpenId");
      
      // 如果已有 OpenId，直接执行回调
      if (openid != null && openid != "") {
        console.log("已有 OpenId，直接执行回调");
        if (typeof callBack === "function") {
          callBack();
        }
        _this.GetJssdkConfig(that);
        return;
      }
      
      // 检查是否正在处理授权（防止重复请求）
      var isProcessing = sessionStorage.getItem("WeixinAuthProcessing");
      if (isProcessing === "true") {
        console.log("正在处理授权，跳过重复请求");
        return;
      }
      
      // 获取 URL 中的 code
      var code = that.$route && that.$route.query && that.$route.query.code;
      //console.log("当前 code:", code);
      
      // 调用 Getauthorize 处理授权
      _this.Getauthorize(code, that, function() {
        if (typeof callBack === "function") {
          callBack();
        }
        _this.GetJssdkConfig(that);
      });
    } else {
      console.log("请使用微信浏览器浏览！");
      //alert("你使用的浏览器不是微信浏览器，会造成分享和支付使用不了！");
      Toast.fail("请使用微信浏览器浏览！");
    }
  }

  /**
   * 公开页面统一入口：进入任意公开页面时调用。
   * 非微信环境直接跳过；微信环境确保 JSSDK config 完成，并把当前页分享重置为默认 logo。
   * 商品等需要自定义分享的页面，在拿到数据后再调 WeiXin.share(...) 覆盖即可。
   * @param {object} storeOrThat Vuex store 或组件实例
   */
  static initPageShare(storeOrThat) {
    if (!WeiXin.IsWeiXin()) return;
    WeiXin.GetJssdkConfig(storeOrThat)
      .then(function() {
        // config 真正就绪后再设默认分享，避免 offline verifying
        WeiXin.setDefaultShare();
      })
      .catch(function(e) {
        console.warn("initPageShare 配置失败：", e);
      });
  }

  /**
   * 真正调用微信分享接口（仅在 JSSDK ready 后由 share() 调用），并按内容去重
   */
  static _applyShare(data) {
    var key = [data.title, data.desc, data.link, data.imgUrl].join("|");
    if (key === _lastShareKey) return; // 内容相同不重复设置，规避 offline verifying
    _lastShareKey = key;
    wx.updateAppMessageShareData && wx.updateAppMessageShareData(data);
    wx.updateTimelineShareData && wx.updateTimelineShareData(data);
    wx.onMenuShareAppMessage && wx.onMenuShareAppMessage(data);
    wx.onMenuShareTimeline && wx.onMenuShareTimeline(data);
  }

  /**
   * 设置微信分享（一个入口同时设置好友/朋友圈，自动兼容新旧接口，自动兜底 logo）。
   * 内部等待 JSSDK config 就绪，页面可在任意时机安全调用。
   * @param {string} title   标题，空则用默认标题
   * @param {string} desc    描述
   * @param {string} imgUrl  图标，空则用站点 logo
   * @param {string} pathname 分享链接路径，空则用当前页 location.href
   */
  static share(title, desc, imgUrl, pathname) {
    var data = {
      title: title || DEFAULT_SHARE_TITLE,
      desc: desc || DEFAULT_SHARE_DESC,
      link: pathname ? location.origin + pathname : location.href,
      imgUrl: imgUrl || DEFAULT_SHARE_LOGO
    };

    // 尚未发起 config（如页面直接调用）时，用全局 store 兜底初始化
    var ensure = _configPromise || WeiXin.GetJssdkConfig(store);
    ensure
      .then(function() {
        wx.ready(function() {
          WeiXin._applyShare(data);
        });
      })
      .catch(function(e) {
        console.warn("share 设置失败：", e);
      });
  }

  /** 全局默认分享（logo 兜底） */
  static setDefaultShare() {
    // 默认分享不应被“与上一次自定义相同”而跳过：切页要重置，故先清 key
    _lastShareKey = "";
    WeiXin._applyShare({
      title: DEFAULT_SHARE_TITLE,
      desc: DEFAULT_SHARE_DESC,
      link: location.href,
      imgUrl: DEFAULT_SHARE_LOGO
    });
  }

  /** @deprecated 旧方法名，保留兼容，内部转调 share */
  static onMenuShareAppMessage(title, desc, imgUrl, pathname) {
    WeiXin.share(title, desc, imgUrl, pathname);
  }
}

export default WeiXin;



// WEBPACK FOOTER //
// ./src/tools/weixin.js